import React from 'react';

import CoreLayout from './layouts/PageLayout/PageLayout';
import ViewPlayer from './components/ViewPlayer/';

export const createRoutes = (store) => {
  return ({
    path: 'recordings/:id',
    component: props => {
      return (
        <CoreLayout store={store} {...props} />
      );
    },
    indexRoute  : ({
      component: props => {
        console.log(props);
        return (
          <div className="container">
            <div className="video-js-responsive-container vjs-hd">
              <ViewPlayer {...{
                autoPlay: true,
                controls: true,
                poster: 'https://www.paragonone.com/assets/img/logo-white.png',
                sources: [{
                  src: 'https://s3.us-east-2.amazonaws.com/paragonone-zoom-cloudrecordings/' + props.params.id + '.mp4',
                }]}} />
            </div>
          </div>
        )
      },
    }),
  });
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/recordings/index.js